import React, { useState } from "react";
import { Eye, EyeOff } from "react-feather"; 
import Footer from "../../component/Footer";
import SellerNavbar from "../../component/SellerNavbar";
import axios from "axios"; // Import axios
import { baseurl } from "../../Baseurl";
import { useNavigate, Link } from "react-router-dom";
import { Spinner } from "react-bootstrap"; // Import Spinner

const SellerRegister = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    emailOtp: "",
    phone: "",
    phoneOtp: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false); // Loading state for spinner
 const [errors, setErrors] = useState({}); 

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(false);
    const [phoneOtpSent, setPhoneOtpSent] = useState(false);

  const navigate = useNavigate(); 


    // Toggle Password Visibility
    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);


  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Toggle password visibility
  // const togglePasswordVisibility = () => {
  //   setShowPassword((prevState) => !prevState);
  // };




    // Request OTP for Email
    const getEmailOtp = async () => {
      if (!formData.email.trim()) {
        setErrors((prev) => ({ ...prev, email: "Email is required" }));
        return;
      }
    
      const requestData = { email: formData.email };  
      console.log("Sending Email OTP Request:", requestData); // Log the sent data
    
      try {
        const response = await axios.post(`${baseurl}generateEmailOtpSeller`, requestData);
        console.log("Email OTP Response:", response.data); // Log the response from backend
    
        setEmailOtpSent(true);
        alert("OTP sent to your email.");
      } catch (error) {
        console.error("Email OTP Error", error.response?.data || error);
        alert(error.response?.data?.message || "Failed to send OTP");
      }
    };

const [isEmailVerified, setIsEmailVerified] = useState(false);
const [isPhoneVerified, setIsPhoneVerified] = useState(false);

const verifyEmailOtp = async () => {
  if (!formData.email.trim() || !formData.emailOtp.trim()) {
    setErrors((prev) => ({
      ...prev,
      emailOtp: "Please enter the OTP for email verification.",
    }));
    return;
  }

  try {
    const response = await axios.post(`${baseurl}verifyEmailOtpSeller`, {
      email: formData.email,
      otp: formData.emailOtp,
    });

    alert(response.data.message);
    setIsEmailVerified(true); // Disable button after success
  } catch (error) {
    console.error("Email OTP Verification Error", error.response?.data || error);
    alert(error.response?.data?.message || "Failed to verify email OTP");
  }
};

  // Request OTP for Phone
  const getPhoneOtp = async () => {
    if (!formData.phone.trim()) {
        setErrors((prev) => ({ ...prev, phone: "Phone is required" }));
        return;
    }

    try {
        console.log("Sending phone OTP request with data:", { phone: formData.phone });

        await axios.post(`${baseurl}generatePhoneOtpSeller`, { phone: formData.phone });

        setPhoneOtpSent(true);
        alert("OTP sent to your phone.");
    } catch (error) {
        console.error("Phone OTP Error", error.response?.data || error);
        alert(error.response?.data?.message || "Failed to send OTP");
    }
};


const verifyPhoneOtp = async () => {
  if (!formData.phone.trim() || !formData.phoneOtp.trim()) {
    setErrors((prev) => ({
      ...prev,
      phoneOtp: "Please enter the OTP for phone verification.",
    }));
    return;
  }

  try {
    const response = await axios.post(`${baseurl}verifyPhoneOtpSeller`, {
      phone: formData.phone,
      otp: formData.phoneOtp,
    });

    alert(response.data.message);
    setIsPhoneVerified(true); // Disable button after success
  } catch (error) {
    console.error("Phone OTP Verification Error", error.response?.data || error);
    alert(error.response?.data?.message || "Failed to verify phone OTP");
  }
};


 


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");
  
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{6,}$/;

  
    if (!passwordRegex.test(formData.password)) {
      setErrorMessage("Password must contain at least one letter, one number, and one special character.");
      return; // prevent form submission
    }
  
    setLoading(true);
    console.log("formData", formData);
  
    try {
      const response = await axios.post(`${baseurl}seller_register`, formData);
      console.log("API Response:", response);
  
      if (response.data.data) {
        const { id, email } = response.data.data;
        localStorage.setItem("seller_id", id);
        localStorage.setItem("seller_email", email);
        localStorage.setItem("seller_first_name", response.data.data.first_name);
  
        setSuccessMessage("Registration successful!");
        setFormData({
          firstName: "",
          middleName: "",
          lastName: "",
          email: "",
          phone: "",
          password: "",
        });
  
        navigate(`/seller/dashboard`);
      } else {
        setErrorMessage(response.data.message || "Registration failed.");
      }
    } catch (error) {
      console.log("API Error:", error.response);
      setErrorMessage(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  


  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 justify-content-center">
              <div className="col-md-5">
                <div className="text-start hed12">Sell On ARAS</div>
                <p className="text-start">
                  Our network connects millions of buyers with sellers of new
                  and used laboratory products. ARAS is your gateway to a vast
                  network of scientists, researchers, and industry experts eager
                  to discover what you have to offer.
                </p>
              </div>

              <div className="col-md-7">
                <div className="reviewcls">
                  <h4 className="review-form-heading">ARAS Seller Register</h4>
                  <p className="payttl">
                    Enter detail to become registered seller.
                  </p>
                  <hr />
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-2">
                      <div className="col-md-4">
                        <label htmlFor="firstName" className="form-label">
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="firstName"
                          name="firstName"
                          className="form-control"
                          placeholder="Enter your first name"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="middleName" className="form-label">
                          Middle Name
                        </label>
                        <input
                          type="text"
                          id="middleName"
                          name="middleName"
                          className="form-control"
                          placeholder="Enter your middle name"
                          value={formData.middleName}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="lastName" className="form-label">
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="lastName"
                          name="lastName"
                          className="form-control"
                          placeholder="Enter your last name"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      {/* <div className="col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div> */}

                      <div className="col-6">
      <label className="form-label">
        Email Address <span className="text-danger">*</span>
      </label>
      <div className="input-group">
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleChange}
          disabled={isEmailVerified} // Disable input if verified
        />
        <button
          type="button"
          className="btn btn-secondary"
          onClick={getEmailOtp}
          disabled={isEmailVerified} // Disable button if verified
        >
          Get OTP
        </button>
      </div>
      {errors.email && <small className="text-danger">{errors.email}</small>}

      <input
        type="text"
        name="emailOtp"
        className="form-control mt-2"
        placeholder="Enter Email OTP"
        value={formData.emailOtp}
        onChange={handleChange}
        disabled={isEmailVerified} // Disable input if verified
      />
      {errors.emailOtp && <small className="text-danger">{errors.emailOtp}</small>}

      <span
        type="button"
        className={`vtgy mt-2 ${isEmailVerified ? "vtgysuccess" : "vtgy"}`}
        onClick={verifyEmailOtp}
        disabled={isEmailVerified} // Disable button after verification
      >
        {isEmailVerified ? "Email OTP Verified ✅" : "Verify Email OTP"}
      </span>
    </div>

                      {/* <div className="col-md-6">
                        <label htmlFor="phone" className="form-label">
                          Phone <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          id="phone"
                          name="phone"
                          className="form-control"
                          placeholder="Enter your phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div> */}




<div className="col-6">
      <label className="form-label">
        Phone <span className="text-danger">*</span>
      </label>
      <div className="input-group">
        <input
          type="number"
          name="phone"
          className="form-control"
          placeholder="Enter your phone"
          value={formData.phone}
          onChange={handleChange}
          disabled={isPhoneVerified} // Disable input if verified
        />
        <button
          type="button"
          className="btn btn-secondary"
          onClick={getPhoneOtp}
          disabled={isPhoneVerified} // Disable button if verified
        >
          Get OTP
        </button>
      </div>
      {errors.phone && <small className="text-danger">{errors.phone}</small>}

      <input
        type="text"
        name="phoneOtp"
        className="form-control mt-2"
        placeholder="Enter Phone OTP"
        value={formData.phoneOtp}
        onChange={handleChange}
        disabled={isPhoneVerified} // Disable input if verified
      />
      {errors.phoneOtp && <small className="text-danger">{errors.phoneOtp}</small>}

      <span
        type="button"
        className={`vtgy mt-2 ${isPhoneVerified ? "vtgysuccess" : "vtgy"}`}
        onClick={verifyPhoneOtp}
        disabled={isPhoneVerified} // Disable button after verification
      >
        {isPhoneVerified ? "Phone OTP Verified ✅" : "Verify Phone OTP"}
      </span>
    </div>





                      <div className="col-12">
                        <label htmlFor="password" className="form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            className="form-control"
                            placeholder="Enter your password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                          />
                          <span
                            className="input-group-text"
                            onClick={togglePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <EyeOff /> : <Eye />}
                          </span>
                        </div>
                      </div>

{/* gst */}

<div className="col-md-12">
                        <label htmlFor="business_name" className="form-label">
                        Business Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="business_name"
                          name="business_name"
                          className="form-control"
                          placeholder="Enter your last name"
                          value={formData.business_name}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-12">
                        <label htmlFor="business_address" className="form-label">
                        Business Address<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="business_address"
                          name="business_address"
                          className="form-control"
                          placeholder="Enter your address"
                          value={formData.business_address}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-12">
                        <label htmlFor="gst_number" className="form-label">
                          GST Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="gst_number"
                          name="gst_number"
                          className="form-control"
                          placeholder="Enter your gst_number"
                          value={formData.gst_number}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="city" className="form-label">
                        City<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="city"
                          name="city"
                          className="form-control"
                          placeholder="Enter your city"
                          value={formData.city}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="state" className="form-label">
                        State<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="state"
                          name="state"
                          className="form-control"
                          placeholder="Enter your state"
                          value={formData.state}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="country" className="form-label">
                        Country<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="country"
                          name="country"
                          className="form-control"
                          placeholder="Enter your country"
                          value={formData.country}
                          onChange={handleChange}
                          required
                        />
                      </div>


                      <div className="col-md-4">
                        <label htmlFor="pincode" className="form-label">
                        Pincode<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="pincode"
                          name="pincode"
                          className="form-control"
                          placeholder="Enter your pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      
                      <div class="form-check mt-3">
  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" required />
  <label class="form-check-label" for="flexCheckDefault">
    I have read and agree to the <a href="/seller/terms" target="_blank">Terms and Conditions</a>.
  </label>
</div>


                    </div>

                    <div className="mt-3">
                      <button type="submit" className="btn submitbtnn w-100">
                        {loading ? (
                          <span><Spinner animation="border" size="sm" /> Creating Account</span>
                        ) : (
                          "Register"
                        )}
                      </button>
                    </div>

                    {/* Display messages */}
                    {errorMessage && <p className="text-danger mt-2">{errorMessage}</p>}
                    {successMessage && <p className="text-success mt-2">{successMessage}</p>}
                  </form>


                  <div className="mt-3 text-center">
                                      <p>
                                        Already have an account?{" "}
                                        <Link
                                          to="/seller/login"
                                          className="text-primary claslnk"
                                        >
                                          SignIn
                                        </Link>
                                      </p>
                                    </div>



                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default SellerRegister;
